import React, { useEffect, useRef, useState } from 'react';

interface SandboxedHtmlProps {
  className?: string;
  html: string;
}

const SandboxedHtml = ({ html, className }: SandboxedHtmlProps) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const [height, setHeight] = useState(0);

  const srcDoc = `
    <base target="_parent">
    <style>
      body { margin: 0; padding: 0; overflow: hidden; font-family: inherit; }
      #wrapper { overflow: hidden; }
    </style>
    <div id="wrapper">${html}</div>
  `;

  useEffect(() => {
    const iframe = iframeRef.current;

    if (!iframe) return;

    const updateHeight = () => {
      const wrapper = iframe.contentDocument?.getElementById('wrapper');

      if (!wrapper) return;

      const newHeight = wrapper.offsetHeight;

      if (newHeight > 0 && newHeight !== height) {
        setHeight(newHeight);
      }
    };

    const interval = setInterval(updateHeight, 16);

    return () => clearInterval(interval);
  }, [html, height]);

  return (
    <iframe
      ref={iframeRef}
      className={className}
      srcDoc={srcDoc}
      style={{
        border: 'none',
        display: 'block',
        height: `${height}px`,
        transition: 'height 0.1s ease',
        width: '100%',
      }}
      title="Embedded Content"
    />
  );
};

export default SandboxedHtml;
